<section class="popup">
    <ng-container *ngTemplateOutlet=" titleTemplate!;">

    </ng-container>
</section>